
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12619',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12619",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.479",
  "data-fetching-client": "static-1.9756",
  "foundations-components": "static-1.8111",
  "foundations-components-legacy": "static-1.1136",
  "foundations-theming": "static-1.4526",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8112",
  "hub-http-shared-msw-handlers": "static-1.10188",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11568",
  "I18n": "static-7.1634",
  "jasmine-runner": "static-1.6555",
  "marketplace-storefront-base": "static-1.12682",
  "quartz": "static-1.7144",
  "react-dlb": "static-1.80",
  "react-rhumb": "static-1.16776",
  "reactive-variable-buffer-atom": "static-1.2952",
  "reporting-testing-lib": "static-1.9848",
  "settings-ui-lib": "static-1.12614",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7306",
  "ui-addon-i18n": "static-1.11245",
  "ui-addon-react-router-dom": "static-1.9634",
  "unified-auth": "static-1.602",
  "unified-auth-core-lib": "static-1.884",
  "usage-tracker": "static-1.7442",
  "usage-tracker-core": "static-1.7292",
  "customer-data-property-utils": "static-1.8190",
  "hub-http": "static-1.6315",
  "integrations-lib": "static-1.16455",
  "marketplace-ui-common": "static-1.20085",
  "property-management-iframe": "static-1.13474",
  "quartz-config": "static-1.922",
  "quartz-core": "static-1.6363",
  "quartz-routing": "static-1.574",
  "quick-fetch": "static-1.3985",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4750",
  "ts-schema": "static-1.4148",
  "ui-universal-auth": "static-1.9088",
  "UIComponents": "static-3.8514",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3468",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3421",
  "quartz-webpack": "static-1.3368",
  "bend-plugin-quartz-routing": "static-1.222",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4380",
  "floating-ui": "static-1.57",
  "foundations-assets": "static-1.4963",
  "foundations-theming-specialty": "static-1.2242",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9516",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.32",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5411",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.489",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2164",
  "ui-fonts": "static-1.830",
  "ui-images": "static-2.1175",
  "bend-plugin-foundations-theming": "static-1.3009",
  "foundations-theming-base": "static-1.3511",
  "stylex": "static-1.34",
  "HeadJS": "static-2.766",
  "hs-test-utils-bend-plugin": "static-1.3223",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4420",
  "ai-components-ui-library": "static-1.9186",
  "ai-rendering-library": "static-1.10495",
  "chirp-fetch": "static-1.1981",
  "connections-embed-lib": "static-1.1154",
  "copilot-toolkit": "static-1.11369",
  "feedback-loader": "static-1.29464",
  "laboratory-lib": "static-3.7249",
  "marketplace-embed": "static-1.22378",
  "marketplace-ui-details": "static-1.9980",
  "marketplace-ui-reviews": "static-1.20040",
  "marketplace-ui-tracking": "static-1.14255",
  "sanitize-text": "static-1.8239",
  "ui-addon-video-player": "static-1.8797",
  "usage-tracker-multi": "static-1.5856",
  "usage-tracker-session-replay": "static-1.5128",
  "wootric-nps": "static-1.7050",
  "quartz-head": "static-1.809",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4747",
  "immer": "static-1.33",
  "immerable": "static-1.4248",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2564",
  "reporting-data": "static-1.67915",
  "cssUtils": "static-1.817",
  "flux-actions": "static-1.343",
  "HubStyle": "static-2.11875",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10302",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10457",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7432",
  "icons": "static-2.651",
  "marketplace-ui-apps-core": "static-1.18617",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4607",
  "foundations-components-test-utils": "static-1.5594",
  "quartz-i18n": "static-1.819",
  "react-input-autosize": "static-2.17",
  "ads-unified-auth-lib": "static-1.293",
  "google-sheets-integration-lib": "static-1.510",
  "microsoft-drive-integration-lib": "static-1.647",
  "slack-ui-library": "static-1.10487",
  "fsm": "static-1.3823",
  "customer-data-objects": "static-1.7772",
  "property-translator": "static-1.5490",
  "hs-locale-management": "static-1.149",
  "frontend-preferences-client": "static-1.8020",
  "hs-promise-utils": "static-1.5685",
  "hubspot-apollo-client": "static-1.4972",
  "integrations-error-boundary-lib": "static-1.13870",
  "integrations-tracking-lib": "static-1.5700",
  "native-integrations-shared-strings": "static-1.7876",
  "reselect": "static-2.16",
  "sanitize": "static-1.4571",
  "superstore": "static-1.4854",
  "ui-shepherd-react": "static-3.10316",
  "ai-settings-ui-library": "static-1.8033",
  "hub-http-janus": "static-1.841",
  "hubspotter-http": "static-1.4719",
  "immutable-less": "static-1.4748",
  "marketplace-ui-client-types": "static-1.17492",
  "nav-meta": "static-1.29882",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18127",
  "inbound-db-properties-service-client": "static-1.3913",
  "property-management-common": "static-1.5762",
  "ui-addon-iframeable": "static-1.9158",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.540",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.819",
  "quartz-test": "static-1.819",
  "quartz-tracking": "static-1.523",
  "trellis-components": "static-1.2183",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.160",
  "bender-build-tools": "static-1.3278",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21734",
  "ContentUtils": "static-1.68621",
  "customer-data-objects-ui-components": "static-1.13125",
  "sassPrefix": "static-1.157",
  "breeze-engine-core": "static-1.298",
  "breeze-onboarding-components": "static-1.190",
  "avatar-components": "static-1.2591",
  "customer-data-filters-ui": "static-1.40109",
  "customer-data-reference-ui-components": "static-1.13264",
  "embedded-academy-lib": "static-1.14610",
  "ExportDialog": "static-6.10475",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41533",
  "reporting-snowflake": "static-1.56533",
  "reporting-ui-components": "static-2.65186",
  "reporting-visualizations": "static-1.59991",
  "ui-addon-teams": "static-1.21675",
  "integrations-reconnect-lib": "static-1.127",
  "magpie-lib": "static-1.5611",
  "navigation-components": "static-1.18245",
  "breeze-engine-lib": "static-1.1020",
  "magpie-types": "static-1.5071",
  "simple-logging-lib": "static-1.3145",
  "ai-studio-lib": "static-1.11883",
  "app-governance-lib": "static-1.1842",
  "developer-experience-shared-components": "static-1.10608",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8100",
  "ui-product-approvals": "static-1.28533",
  "ui-tool-access": "static-1.10242",
  "usage-based-billing-components-lib": "static-1.9342",
  "usage-tracker-anonymous": "static-1.5859",
  "usage-tracker-public": "static-1.7253",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3654",
  "persist-promise": "static-1.3793",
  "reference-resolvers": "static-1.8268",
  "ui-extensibility-client-types": "static-1.4018",
  "hubspot-apollo-cache": "static-1.431",
  "universal-page-editor-lib": "static-1.3111",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3040",
  "atom": "static-1.5169",
  "merchandise-lib": "static-1.265",
  "purchase-motions-components": "static-1.6061",
  "salesImages": "static-1.526",
  "batch-promise": "static-1.1636",
  "crm-component-utils": "static-1.39319",
  "crm-properties-common-lib": "static-1.5982",
  "customer-data-properties": "static-1.51903",
  "framework-data-schema-resolvers": "static-1.6984",
  "property-value-citations": "static-1.2517",
  "reference-resolvers-lite": "static-1.8192",
  "ui-business-units-lib": "static-1.9156",
  "navigation-messaging": "static-1.7572",
  "hubspotter-http-shared-msw-handlers": "static-1.10186",
  "base-ui": "static-1.12",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1034",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4907",
  "content-icons-ui": "static-1.2251",
  "customer-data-ui-utilities": "static-1.9920",
  "conversations-skeleton-state": "static-1.7344",
  "crm-message-bus": "static-1.43221",
  "customer-data-filters-ui-msw-helpers": "static-1.22544",
  "events-data-lib": "static-1.324",
  "FormUrlGenerator": "static-2.4815",
  "framework-builder-read-service-client": "static-1.4073",
  "framework-data-schema-quick-fetch": "static-1.6889",
  "multi-account-reference-resolvers": "static-1.1076",
  "onboarding-tours": "static-1.16771",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13944",
  "academy-common-lib": "static-1.14070",
  "content-assistance-lib": "static-1.7897",
  "dashboard-lib": "static-1.81891",
  "file-manager-components": "static-1.23852",
  "getting-started-shared-tasks": "static-1.18667",
  "hubspot-prosemirror": "static-1.18484",
  "hubspot-prosemirror-plugins": "static-1.18476",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19985",
  "share-with-third-party-component-lib": "static-1.8798",
  "ui-addon-draggable": "static-3.4856",
  "ui-asset-management-lib": "static-1.11155",
  "user-context": "static-1.5204",
  "growth-payments-core": "static-1.25650",
  "reporting-plugins": "static-1.10480",
  "reporting-reports": "static-1.67593",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.820",
  "nest": "static-1.325",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10722",
  "framework-listing-lib": "static-2.28952",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30934",
  "apps-service-types": "static-1.3910",
  "oauth-service-types": "static-1.4345",
  "react-dnd-compat": "static-1.4708",
  "ui-product-approvals-common": "static-1.428",
  "onboarding-scopes": "static-1.6556",
  "onboarding-tours-client": "static-1.4985",
  "platform-infra-nav-components": "static-1.7741",
  "subscription-experience-data-types": "static-1.15047",
  "crm-record-cards-service-types": "static-1.3658",
  "location-customization-utils-lib": "static-1.9529",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6064",
  "signup-constants": "static-1.19055",
  "signup-ui-url-generator": "static-2.8152",
  "card-properties-lib": "static-1.44473",
  "commerce-subscription-lib": "static-1.37391",
  "crm-actions": "static-1.6433",
  "crm-cards-sdk": "static-1.43855",
  "customer-data-properties-shared-msw-handlers": "static-1.9515",
  "customer-data-tracking": "static-1.6984",
  "hs-resources": "static-1.269",
  "pulse": "static-1.690",
  "calling-global-api": "static-1.64830",
  "calling-internal-common": "static-1.31404",
  "calling-lifecycle-internal": "static-1.66212",
  "calling-lifecycle-messages": "static-1.58506",
  "commerce-products-lib": "static-1.9879",
  "conditional-properties-service-client": "static-1.3865",
  "crm-links": "static-1.6400",
  "crm-pipelines-api-client-types": "static-1.4206",
  "external-options-client-types": "static-1.4199",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4289",
  "meetings-icalendar-utils-lib": "static-1.728",
  "multi-currency-client-types": "static-1.3758",
  "object-builder-ui-client": "static-1.49062",
  "pipeline-validation-client-types": "static-1.4034",
  "smart-property-lib": "static-1.7658",
  "tiered-pricing": "static-1.1425",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11083",
  "fdsr-migration-layer": "static-1.103",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1107",
  "growth-data-modal": "static-1.5574",
  "growth-onboarding-confetti": "static-1.3160",
  "growth-onboarding-next-action-utils": "static-1.2190",
  "onboarding-tours-utils": "static-1.837",
  "ui-shepherd-tracker": "static-1.7697",
  "academy-service-client": "static-1.3777",
  "SafeStorage": "static-1.4493",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39351",
  "FileManagerLib": "static-1.39492",
  "video-embed": "static-1.36068",
  "ui-coaching-tips": "static-1.28818",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11576",
  "video-data-lib": "static-1.35234",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8557",
  "payment-link-components": "static-1.23761",
  "ui-addon-emoji-picker": "static-1.9981",
  "EmailSignatureEditor": "static-1.24573",
  "viral-links-lib": "static-1.7164",
  "data-token-picker": "static-1.16565",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.319",
  "timezone-utils": "static-2.5338",
  "seat-types-lib": "static-1.228",
  "getting-started-shared-tasks-store": "static-1.17785",
  "ui-addon-opt": "static-4.8454",
  "campaign-roi-lib": "static-1.9361",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25636",
  "framework-data-table": "static-2.12121",
  "marketing-platform-lib": "static-1.6958",
  "nudge-client-utils": "static-1.2771",
  "nudge-custom-ui-functions": "static-1.1193",
  "switchboard-lib": "static-1.316",
  "app-users-service-client": "static-1.5701",
  "app-users-service-types": "static-1.5109",
  "mini-checkout-client": "static-1.27031",
  "onboarding-utils": "static-1.5454",
  "permissions-shared-i18n-strings-fe": "static-1.2058",
  "ui-coaching-tips-shared-config": "static-1.28803",
  "edison-service-client-types": "static-1.482",
  "crm_data": "static-4.92253",
  "customer-data-sidebar": "static-2.46268",
  "enrichment-properties-lib": "static-1.16776",
  "ui-addon-draggable-compat": "static-2.4353",
  "universal-record-utils-lib": "static-1.1177",
  "commerce-billing-lib": "static-1.19370",
  "commerce-shared-components-lib": "static-1.18749",
  "commerce-tools-ui-lib": "static-1.10616",
  "crm-fe-perf": "static-1.22998",
  "event-emitter": "static-1.1043",
  "bend-plugin-pulse": "static-1.193",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31411",
  "shared-worker-versioning": "static-1.11130",
  "calling-usage-tracker": "static-1.6637",
  "voice-sms-access-library": "static-1.1352",
  "commerce-permissions": "static-1.871",
  "products-iframe-lib": "static-1.8181",
  "products-ui-components-shared-msw-handlers": "static-1.10570",
  "data-agent-kit": "static-1.341",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10271",
  "policy-lib": "static-1.6874",
  "react-tinymce": "static-1.55488",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10334",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54614",
  "tinymce-plugins": "static-1.57728",
  "tinymce-themes": "static-1.56584",
  "onboarding-data-sync-lib": "static-1.2118",
  "growth-onboarding-next-action-components": "static-1.2218",
  "user-context-client": "static-1.4678",
  "audio-components": "static-1.6056",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37003",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4631",
  "video-components": "static-1.13578",
  "outpost": "static-1.4265",
  "growth-onboarding-feedback-components": "static-1.6673",
  "content-media-composition-data-lib": "static-1.12601",
  "content-media-compositions": "static-2.16608",
  "media-bridge-lib": "static-1.19082",
  "commerce-tours-lib": "static-1.6269",
  "growth-onboarding-reliability": "static-1.5175",
  "sales-checkout-service-client": "static-1.3689",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21833",
  "sales-email-signature-service-client": "static-1.3942",
  "ts-utils-lib": "static-1.266",
  "crm-export-dialog": "static-1.6380",
  "crm-index-associations-lib": "static-1.6538",
  "crm-view-components": "static-1.552",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7424",
  "nudge-custom-function-registry": "static-1.2528",
  "nudge-renderer-utils": "static-1.2847",
  "whisper-core-api": "static-1.6817",
  "InboxConnectUtils": "static-4.15054",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5742",
  "settings-content-modals": "static-1.46346",
  "crm_universal": "static-1.22165",
  "customer-data-email": "static-1.18193",
  "card-payment-highlight-lib": "static-1.37436",
  "card-subscription-highlight-lib": "static-1.39814",
  "commerce-contract-lib": "static-1.12523",
  "invoices-highlight-card-lib": "static-1.55013",
  "orders-highlight-card-lib": "static-1.21722",
  "products-highlight-card-lib": "static-1.18162",
  "quotes-highlight-card-lib": "static-1.72331",
  "crm-source-interpretation-lib": "static-1.5437",
  "crm-object-search-query-utilities": "static-1.9784",
  "utility-belt": "static-1.2627",
  "payments-enrollment-embed-lib": "static-1.23180",
  "stripe-embedded-components": "static-1.7667",
  "customer-data-rte": "static-1.33236",
  "cv-backend-services": "static-1.1555",
  "growth-onboarding-empty-states": "static-1.5904",
  "payments-post-enroll-local-storage-lib": "static-1.5201",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38421",
  "trials-service-types": "static-1.3974",
  "calling-orchestration-schema": "static-1.36129",
  "sales-views-client-types": "static-1.4351",
  "hub-http-contrib": "static-1.3136",
  "interframe": "static-3.4854",
  "tinymce-data": "static-1.40699",
  "ui-addon-sales-email": "static-1.5304",
  "layout-dnd-components": "static-1.12617",
  "layout-dnd-utils": "static-1.11592",
  "ui-brand-identity-lib": "static-1.15604",
  "NamespacedHubStyle": "static-2.9126",
  "meetings-connect-utils-lib": "static-1.7698",
  "social-insights-client-types": "static-1.22301",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4257",
  "checkout-sdk": "static-3.23874",
  "checkout-service-types": "static-1.3868",
  "company-details-components": "static-1.6292",
  "payment-method-components": "static-1.6971",
  "pricing-pages-ui-components": "static-1.14594",
  "quote-checkout-service-types": "static-1.3559",
  "upgrade-catalog-service-types": "static-1.3614",
  "access-control-lib": "static-1.10528",
  "EmailComponents": "static-1.55021",
  "EmailData": "static-1.53698",
  "redux-less": "static-2.9578",
  "sequences-lib": "static-1.8199",
  "ui-gdpr-components": "static-1.10445",
  "products-ui-components": "static-1.40397",
  "accounting-integrations-ui-components": "static-1.7210",
  "invoices-ui-lib": "static-1.55029",
  "commerce-products-api": "static-1.2428",
  "invoices-iframe-lib": "static-1.57087",
  "quotes-modal-lib": "static-1.103009",
  "quotes-ui-lib": "static-1.81052",
  "stripe-connect-js": "static-1.70",
  "draft-content-plugins": "static-1.28507",
  "ContentData": "static-1.68696",
  "layout-data-lib": "static-1.9917",
  "hub-http-rxjs": "static-1.807",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4032",
  "billing-payments-client-types": "static-1.4085",
  "react-performance-metrics-lib": "static-1.650",
  "account-and-billing-fintech-outages": "static-3.18701",
  "pricing-pages-api": "static-1.14459",
  "ContentComponents": "static-2.71577",
  "marketing-contacts-lib": "static-1.10359",
  "marketing-email-service-types": "static-1.1973",
  "messaging-editing-lib": "static-1.46530",
  "messaging-usage-based-billing-components-lib": "static-1.1392",
  "automation-ui-source-apps": "static-1.19150",
  "automation-ui-types": "static-1.20068",
  "messaging-types-lib": "static-1.46267",
  "onboarding-settings-client": "static-1.4598",
  "sequences-client-types-lib": "static-1.8056",
  "commerce-tax-lib": "static-1.630",
  "price-books-api": "static-1.1173",
  "price-books-components": "static-1.1231",
  "property-description-translator": "static-1.3934",
  "ramp-editor": "static-1.359",
  "commerce-analytics-service-client": "static-1.3677",
  "totals-ui-components": "static-1.23850",
  "SalesContentIndexUI": "static-3.9378",
  "advanced-menus-core": "static-1.15276",
  "advanced-menus-lib": "static-1.12191",
  "ui-memberships-settings-lib": "static-1.34295",
  "segments-query-core": "static-1.1512",
  "automation-ui-ubb": "static-1.5984",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7432",
  "data-token-views": "static-1.16546",
  "forms-utils-lib": "static-1.12753",
  "payments-embed-points-lib": "static-1.13220",
  "simple-menus-core": "static-1.15275",
  "simple-menus-lib": "static-1.16792",
  "videoconference-integration-components": "static-1.6949",
  "marketing-contacts-client": "static-1.7608",
  "automation-applications-service-types": "static-1.3594",
  "automation-platform-service-types": "static-1.2626",
  "ContentEditorUI": "static-2.77362",
  "short-messages-app-service-client": "static-1.4029",
  "web-interactives-components": "static-1.13916",
  "web-interactives-data": "static-1.13917",
  "messaging-shared-utils-lib": "static-1.841",
  "messaging-user-info-utils-lib": "static-1.1011",
  "email-portal-health-service-types": "static-1.1071",
  "line-items-api": "static-1.830",
  "commerce-totals-service-types": "static-1.3887",
  "FireAlarmUi": "static-1.4579",
  "sales-templates-service-types-lib": "static-1.4238",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22004",
  "automation-ui-usage-tracking": "static-1.21467",
  "data-studio-ubb": "static-1.2988",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27227",
  "collaboration-sidebar": "static-1.58096",
  "content-management-data-lib": "static-1.5552",
  "copilot-plugins": "static-1.11342",
  "cta-picker": "static-1.36645",
  "customer-agent-discovery-components-lib": "static-1.3345",
  "editor-components": "static-1.13358",
  "editor-iframe-lib": "static-1.8529",
  "error-messaging-js": "static-1.5286",
  "FormsCommonComponents": "static-1.86111",
  "pictos": "static-7.186",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10740",
  "SharedLegalStrings": "static-1.1839",
  "smart-content-core": "static-1.42691",
  "smart-content-lib": "static-1.43344",
  "social-composer-lib": "static-1.59490",
  "structured-content-lib": "static-1.25433",
  "theme-previewer-lib": "static-1.53492",
  "tinymce-copilot": "static-1.16682",
  "xray-recommendation-lib": "static-1.8031",
  "automation-ui-routing": "static-1.21425",
  "sql-reporting-client-types": "static-1.5716",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42391",
  "campaigns-utils-lib": "static-1.3283",
  "reporting-enablement": "static-1.23247",
  "chatspot-widget-iframe": "static-1.21725",
  "collaboration-sidebar-common": "static-1.2893",
  "forms-ai-lib": "static-1.4462",
  "codemirror-dlb": "static-1.58921",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6528",
  "report-customization-components": "static-1.13402",
  "data-quality-ui-library": "static-1.13272",
  "reporting-filters": "static-1.548",
  "reporting-insights-lib": "static-1.2015"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12619",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.479",
  "data-fetching-client": "/data-fetching-client/static-1.9756",
  "foundations-components": "/foundations-components/static-1.8111",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1136",
  "foundations-theming": "/foundations-theming/static-1.4526",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8112",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10188",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11568",
  "I18n": "/I18n/static-7.1634",
  "jasmine-runner": "/jasmine-runner/static-1.6555",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12682",
  "quartz": "/quartz/static-1.7144",
  "react-dlb": "/react-dlb/static-1.80",
  "react-rhumb": "/react-rhumb/static-1.16776",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2952",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9848",
  "settings-ui-lib": "/settings-ui-lib/static-1.12614",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7306",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11245",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9634",
  "unified-auth": "/unified-auth/static-1.602",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.884",
  "usage-tracker": "/usage-tracker/static-1.7442",
  "usage-tracker-core": "/usage-tracker-core/static-1.7292",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8190",
  "hub-http": "/hub-http/static-1.6315",
  "integrations-lib": "/integrations-lib/static-1.16455",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20085",
  "property-management-iframe": "/property-management-iframe/static-1.13474",
  "quartz-config": "/quartz-config/static-1.922",
  "quartz-core": "/quartz-core/static-1.6363",
  "quartz-routing": "/quartz-routing/static-1.574",
  "quick-fetch": "/quick-fetch/static-1.3985",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4750",
  "ts-schema": "/ts-schema/static-1.4148",
  "ui-universal-auth": "/ui-universal-auth/static-1.9088",
  "UIComponents": "/UIComponents/static-3.8514",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3468",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3421",
  "quartz-webpack": "/quartz-webpack/static-1.3368",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.222",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4380",
  "floating-ui": "/floating-ui/static-1.57",
  "foundations-assets": "/foundations-assets/static-1.4963",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2242",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9516",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.32",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5411",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2164",
  "ui-fonts": "/ui-fonts/static-1.830",
  "ui-images": "/ui-images/static-2.1175",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3009",
  "foundations-theming-base": "/foundations-theming-base/static-1.3511",
  "stylex": "/stylex/static-1.34",
  "HeadJS": "/HeadJS/static-2.766",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3223",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4420",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9186",
  "ai-rendering-library": "/ai-rendering-library/static-1.10495",
  "chirp-fetch": "/chirp-fetch/static-1.1981",
  "connections-embed-lib": "/connections-embed-lib/static-1.1154",
  "copilot-toolkit": "/copilot-toolkit/static-1.11369",
  "feedback-loader": "/feedback-loader/static-1.29464",
  "laboratory-lib": "/laboratory-lib/static-3.7249",
  "marketplace-embed": "/marketplace-embed/static-1.22378",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9980",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20040",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14255",
  "sanitize-text": "/sanitize-text/static-1.8239",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8797",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5856",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5128",
  "wootric-nps": "/wootric-nps/static-1.7050",
  "quartz-head": "/quartz-head/static-1.809",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4747",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4248",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2564",
  "reporting-data": "/reporting-data/static-1.67915",
  "cssUtils": "/cssUtils/static-1.817",
  "flux-actions": "/flux-actions/static-1.343",
  "HubStyle": "/HubStyle/static-2.11875",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10302",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10457",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7432",
  "icons": "/icons/static-2.651",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18617",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4607",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5594",
  "quartz-i18n": "/quartz-i18n/static-1.819",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.293",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.510",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.647",
  "slack-ui-library": "/slack-ui-library/static-1.10487",
  "fsm": "/fsm/static-1.3823",
  "customer-data-objects": "/customer-data-objects/static-1.7772",
  "property-translator": "/property-translator/static-1.5490",
  "hs-locale-management": "/hs-locale-management/static-1.149",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8020",
  "hs-promise-utils": "/hs-promise-utils/static-1.5685",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4972",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13870",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5700",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7876",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4571",
  "superstore": "/superstore/static-1.4854",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10316",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8033",
  "hub-http-janus": "/hub-http-janus/static-1.841",
  "hubspotter-http": "/hubspotter-http/static-1.4719",
  "immutable-less": "/immutable-less/static-1.4748",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17492",
  "nav-meta": "/nav-meta/static-1.29882",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18127",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3913",
  "property-management-common": "/property-management-common/static-1.5762",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9158",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.540",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.819",
  "quartz-test": "/quartz-test/static-1.819",
  "quartz-tracking": "/quartz-tracking/static-1.523",
  "trellis-components": "/trellis-components/static-1.2183",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.160",
  "bender-build-tools": "/bender-build-tools/static-1.3278",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21734",
  "ContentUtils": "/ContentUtils/static-1.68621",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13125",
  "sassPrefix": "/sassPrefix/static-1.157",
  "breeze-engine-core": "/breeze-engine-core/static-1.298",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.190",
  "avatar-components": "/avatar-components/static-1.2591",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40109",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13264",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14610",
  "ExportDialog": "/ExportDialog/static-6.10475",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41533",
  "reporting-snowflake": "/reporting-snowflake/static-1.56533",
  "reporting-ui-components": "/reporting-ui-components/static-2.65186",
  "reporting-visualizations": "/reporting-visualizations/static-1.59991",
  "ui-addon-teams": "/ui-addon-teams/static-1.21675",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.127",
  "magpie-lib": "/magpie-lib/static-1.5611",
  "navigation-components": "/navigation-components/static-1.18245",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1020",
  "magpie-types": "/magpie-types/static-1.5071",
  "simple-logging-lib": "/simple-logging-lib/static-1.3145",
  "ai-studio-lib": "/ai-studio-lib/static-1.11883",
  "app-governance-lib": "/app-governance-lib/static-1.1842",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10608",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8100",
  "ui-product-approvals": "/ui-product-approvals/static-1.28533",
  "ui-tool-access": "/ui-tool-access/static-1.10242",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9342",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5859",
  "usage-tracker-public": "/usage-tracker-public/static-1.7253",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3654",
  "persist-promise": "/persist-promise/static-1.3793",
  "reference-resolvers": "/reference-resolvers/static-1.8268",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4018",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.431",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3111",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3040",
  "atom": "/atom/static-1.5169",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "purchase-motions-components": "/purchase-motions-components/static-1.6061",
  "salesImages": "/salesImages/static-1.526",
  "batch-promise": "/batch-promise/static-1.1636",
  "crm-component-utils": "/crm-component-utils/static-1.39319",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5982",
  "customer-data-properties": "/customer-data-properties/static-1.51903",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6984",
  "property-value-citations": "/property-value-citations/static-1.2517",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8192",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9156",
  "navigation-messaging": "/navigation-messaging/static-1.7572",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10186",
  "base-ui": "/base-ui/static-1.12",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1034",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4907",
  "content-icons-ui": "/content-icons-ui/static-1.2251",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9920",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7344",
  "crm-message-bus": "/crm-message-bus/static-1.43221",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22544",
  "events-data-lib": "/events-data-lib/static-1.324",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4815",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4073",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6889",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1076",
  "onboarding-tours": "/onboarding-tours/static-1.16771",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13944",
  "academy-common-lib": "/academy-common-lib/static-1.14070",
  "content-assistance-lib": "/content-assistance-lib/static-1.7897",
  "dashboard-lib": "/dashboard-lib/static-1.81891",
  "file-manager-components": "/file-manager-components/static-1.23852",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18667",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18484",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18476",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19985",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8798",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4856",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11155",
  "user-context": "/user-context/static-1.5204",
  "growth-payments-core": "/growth-payments-core/static-1.25650",
  "reporting-plugins": "/reporting-plugins/static-1.10480",
  "reporting-reports": "/reporting-reports/static-1.67593",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.820",
  "nest": "/nest/static-1.325",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10722",
  "framework-listing-lib": "/framework-listing-lib/static-2.28952",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30934",
  "apps-service-types": "/apps-service-types/static-1.3910",
  "oauth-service-types": "/oauth-service-types/static-1.4345",
  "react-dnd-compat": "/react-dnd-compat/static-1.4708",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.428",
  "onboarding-scopes": "/onboarding-scopes/static-1.6556",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4985",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7741",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15047",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3658",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9529",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6064",
  "signup-constants": "/signup-constants/static-1.19055",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8152",
  "card-properties-lib": "/card-properties-lib/static-1.44473",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37391",
  "crm-actions": "/crm-actions/static-1.6433",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43855",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9515",
  "customer-data-tracking": "/customer-data-tracking/static-1.6984",
  "hs-resources": "/hs-resources/static-1.269",
  "pulse": "/pulse/static-1.690",
  "calling-global-api": "/calling-global-api/static-1.64830",
  "calling-internal-common": "/calling-internal-common/static-1.31404",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66212",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58506",
  "commerce-products-lib": "/commerce-products-lib/static-1.9879",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3865",
  "crm-links": "/crm-links/static-1.6400",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4206",
  "external-options-client-types": "/external-options-client-types/static-1.4199",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4289",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.728",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3758",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49062",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4034",
  "smart-property-lib": "/smart-property-lib/static-1.7658",
  "tiered-pricing": "/tiered-pricing/static-1.1425",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11083",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.103",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1107",
  "growth-data-modal": "/growth-data-modal/static-1.5574",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3160",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2190",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.837",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7697",
  "academy-service-client": "/academy-service-client/static-1.3777",
  "SafeStorage": "/SafeStorage/static-1.4493",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39351",
  "FileManagerLib": "/FileManagerLib/static-1.39492",
  "video-embed": "/video-embed/static-1.36068",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28818",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11576",
  "video-data-lib": "/video-data-lib/static-1.35234",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8557",
  "payment-link-components": "/payment-link-components/static-1.23761",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9981",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24573",
  "viral-links-lib": "/viral-links-lib/static-1.7164",
  "data-token-picker": "/data-token-picker/static-1.16565",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.319",
  "timezone-utils": "/timezone-utils/static-2.5338",
  "seat-types-lib": "/seat-types-lib/static-1.228",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17785",
  "ui-addon-opt": "/ui-addon-opt/static-4.8454",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9361",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25636",
  "framework-data-table": "/framework-data-table/static-2.12121",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6958",
  "nudge-client-utils": "/nudge-client-utils/static-1.2771",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1193",
  "switchboard-lib": "/switchboard-lib/static-1.316",
  "app-users-service-client": "/app-users-service-client/static-1.5701",
  "app-users-service-types": "/app-users-service-types/static-1.5109",
  "mini-checkout-client": "/mini-checkout-client/static-1.27031",
  "onboarding-utils": "/onboarding-utils/static-1.5454",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2058",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28803",
  "edison-service-client-types": "/edison-service-client-types/static-1.482",
  "crm_data": "/crm_data/static-4.92253",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46268",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16776",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4353",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1177",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19370",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18749",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10616",
  "crm-fe-perf": "/crm-fe-perf/static-1.22998",
  "event-emitter": "/event-emitter/static-1.1043",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.193",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31411",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11130",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6637",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1352",
  "commerce-permissions": "/commerce-permissions/static-1.871",
  "products-iframe-lib": "/products-iframe-lib/static-1.8181",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10570",
  "data-agent-kit": "/data-agent-kit/static-1.341",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10271",
  "policy-lib": "/policy-lib/static-1.6874",
  "react-tinymce": "/react-tinymce/static-1.55488",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10334",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54614",
  "tinymce-plugins": "/tinymce-plugins/static-1.57728",
  "tinymce-themes": "/tinymce-themes/static-1.56584",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2118",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2218",
  "user-context-client": "/user-context-client/static-1.4678",
  "audio-components": "/audio-components/static-1.6056",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37003",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4631",
  "video-components": "/video-components/static-1.13578",
  "outpost": "/outpost/static-1.4265",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6673",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12601",
  "content-media-compositions": "/content-media-compositions/static-2.16608",
  "media-bridge-lib": "/media-bridge-lib/static-1.19082",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6269",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5175",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3689",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21833",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3942",
  "ts-utils-lib": "/ts-utils-lib/static-1.266",
  "crm-export-dialog": "/crm-export-dialog/static-1.6380",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6538",
  "crm-view-components": "/crm-view-components/static-1.552",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7424",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2528",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2847",
  "whisper-core-api": "/whisper-core-api/static-1.6817",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15054",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5742",
  "settings-content-modals": "/settings-content-modals/static-1.46346",
  "crm_universal": "/crm_universal/static-1.22165",
  "customer-data-email": "/customer-data-email/static-1.18193",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37436",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39814",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12523",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55013",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21722",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18162",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72331",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5437",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9784",
  "utility-belt": "/utility-belt/static-1.2627",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23180",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7667",
  "customer-data-rte": "/customer-data-rte/static-1.33236",
  "cv-backend-services": "/cv-backend-services/static-1.1555",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5904",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5201",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38421",
  "trials-service-types": "/trials-service-types/static-1.3974",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36129",
  "sales-views-client-types": "/sales-views-client-types/static-1.4351",
  "hub-http-contrib": "/hub-http-contrib/static-1.3136",
  "interframe": "/interframe/static-3.4854",
  "tinymce-data": "/tinymce-data/static-1.40699",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5304",
  "layout-dnd-components": "/layout-dnd-components/static-1.12617",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11592",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15604",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9126",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7698",
  "social-insights-client-types": "/social-insights-client-types/static-1.22301",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4257",
  "checkout-sdk": "/checkout-sdk/static-3.23874",
  "checkout-service-types": "/checkout-service-types/static-1.3868",
  "company-details-components": "/company-details-components/static-1.6292",
  "payment-method-components": "/payment-method-components/static-1.6971",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14594",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3559",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3614",
  "access-control-lib": "/access-control-lib/static-1.10528",
  "EmailComponents": "/EmailComponents/static-1.55021",
  "EmailData": "/EmailData/static-1.53698",
  "redux-less": "/redux-less/static-2.9578",
  "sequences-lib": "/sequences-lib/static-1.8199",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10445",
  "products-ui-components": "/products-ui-components/static-1.40397",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7210",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55029",
  "commerce-products-api": "/commerce-products-api/static-1.2428",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57087",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103009",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81052",
  "stripe-connect-js": "/stripe-connect-js/static-1.70",
  "draft-content-plugins": "/draft-content-plugins/static-1.28507",
  "ContentData": "/ContentData/static-1.68696",
  "layout-data-lib": "/layout-data-lib/static-1.9917",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.807",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4032",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4085",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.650",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18701",
  "pricing-pages-api": "/pricing-pages-api/static-1.14459",
  "ContentComponents": "/ContentComponents/static-2.71577",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10359",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1973",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46530",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1392",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19150",
  "automation-ui-types": "/automation-ui-types/static-1.20068",
  "messaging-types-lib": "/messaging-types-lib/static-1.46267",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4598",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8056",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.630",
  "price-books-api": "/price-books-api/static-1.1173",
  "price-books-components": "/price-books-components/static-1.1231",
  "property-description-translator": "/property-description-translator/static-1.3934",
  "ramp-editor": "/ramp-editor/static-1.359",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3677",
  "totals-ui-components": "/totals-ui-components/static-1.23850",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9378",
  "advanced-menus-core": "/advanced-menus-core/static-1.15276",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12191",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34295",
  "segments-query-core": "/segments-query-core/static-1.1512",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5984",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7432",
  "data-token-views": "/data-token-views/static-1.16546",
  "forms-utils-lib": "/forms-utils-lib/static-1.12753",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13220",
  "simple-menus-core": "/simple-menus-core/static-1.15275",
  "simple-menus-lib": "/simple-menus-lib/static-1.16792",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6949",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7608",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3594",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2626",
  "ContentEditorUI": "/ContentEditorUI/static-2.77362",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4029",
  "web-interactives-components": "/web-interactives-components/static-1.13916",
  "web-interactives-data": "/web-interactives-data/static-1.13917",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.841",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1011",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1071",
  "line-items-api": "/line-items-api/static-1.830",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3887",
  "FireAlarmUi": "/FireAlarmUi/static-1.4579",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4238",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22004",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21467",
  "data-studio-ubb": "/data-studio-ubb/static-1.2988",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27227",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58096",
  "content-management-data-lib": "/content-management-data-lib/static-1.5552",
  "copilot-plugins": "/copilot-plugins/static-1.11342",
  "cta-picker": "/cta-picker/static-1.36645",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3345",
  "editor-components": "/editor-components/static-1.13358",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8529",
  "error-messaging-js": "/error-messaging-js/static-1.5286",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86111",
  "pictos": "/pictos/static-7.186",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10740",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1839",
  "smart-content-core": "/smart-content-core/static-1.42691",
  "smart-content-lib": "/smart-content-lib/static-1.43344",
  "social-composer-lib": "/social-composer-lib/static-1.59490",
  "structured-content-lib": "/structured-content-lib/static-1.25433",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53492",
  "tinymce-copilot": "/tinymce-copilot/static-1.16682",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8031",
  "automation-ui-routing": "/automation-ui-routing/static-1.21425",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5716",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42391",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3283",
  "reporting-enablement": "/reporting-enablement/static-1.23247",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21725",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2893",
  "forms-ai-lib": "/forms-ai-lib/static-1.4462",
  "codemirror-dlb": "/codemirror-dlb/static-1.58921",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6528",
  "report-customization-components": "/report-customization-components/static-1.13402",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13272",
  "reporting-filters": "/reporting-filters/static-1.548",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2015"
}
};
